"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

var _options_list = _interopRequireDefault(require("./shared/options_list"));

var _text_box = _interopRequireDefault(require("./text_box"));

var _debounce = _interopRequireDefault(require("./utils/debounce"));

require("../css/search.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Search =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "UNSAFE_componentWillMount", function () {
      _this.delayedCallback = (0, _debounce.default)(function (event) {
        if (_this.props.onChange) {
          _this.props.onChange(event.target.value);
        }
      }, _this.props.delay);
      window.addEventListener('click', _this.handleWindowClick);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var value = nextProps.value;

      _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      _this.delayedCallback.cancel();

      window.removeEventListener('click', _this.handleWindowClick);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleWindowClick", function () {
      _this.closeSuggestion();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setSuggestion", function (value) {
      _this.setState({
        closed: true,
        suggestionsFiltered: [],
        value: value
      });

      _this.props.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOptionMouseDown", function (event, option) {
      _this.setSuggestion(option.value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOptionMouseMove", function (event, option) {
      var _this$state = _this.state,
          highlightedIndex = _this$state.highlightedIndex,
          suggestionsFiltered = _this$state.suggestionsFiltered;
      var onAction = _this.props.onAction;
      var highlightedSuggestion = suggestionsFiltered.findIndex(function (opt) {
        return opt.value === option.value;
      });
      event.preventDefault();
      var index;

      if (onAction) {
        var isActionHighlighted = event.target.getElementsByTagName('a')[0].id === 'action';
        index = isActionHighlighted ? 0 : highlightedSuggestion + 1;
      } else {
        index = highlightedSuggestion;
      }

      if (index !== highlightedIndex) {
        _this.setState({
          highlightedIndex: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOnKeyDown", function (event) {
      var suggestionsFiltered = _this.state.suggestionsFiltered;
      var onAction = _this.props.onAction;

      if (!suggestionsFiltered.length && !onAction) {
        return;
      }

      var selectedIndex = _this.state.selectedIndex;
      var optionsLength = onAction ? suggestionsFiltered.length + 1 : suggestionsFiltered.length;

      switch (event.keyCode) {
        case 38:
          // UP
          if (selectedIndex > 0) {
            selectedIndex -= 1;
          }

          _this.setState({
            selectedIndex: selectedIndex
          });

          event.preventDefault();
          break;

        case 40:
          // DOWN
          if (selectedIndex < optionsLength - 1) {
            selectedIndex += 1;
          }

          _this.setState({
            selectedIndex: selectedIndex
          });

          event.preventDefault();
          break;

        case 27:
          // ESC
          _this.closeSuggestion();

          event.preventDefault();
          break;

        case 13:
          // ENTER
          _this.setState({
            selectedIndex: 0
          });

          if (onAction) {
            if (selectedIndex === 0) {
              _this.setSuggestion(event.target.value);

              _this.props.onAction(event, event.target.value);
            } else {
              _this.setSuggestion(suggestionsFiltered[selectedIndex - 1].value);
            }
          } else {
            _this.setSuggestion(suggestionsFiltered[selectedIndex].value);
          }

          event.preventDefault();
          break;

        default:
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (value, event) {
      var suggestions = _this.props.suggestions;
      event.persist();

      _this.setState({
        closed: false,
        suggestionsFiltered: suggestions ? _this.filterSuggestions(suggestions, value) : [],
        value: value
      });

      _this.delayedCallback(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeSuggestion", function () {
      var closed = _this.state.closed;

      if (closed) {
        return;
      }

      _this.setState({
        closed: true,
        selectedIndex: 0,
        suggestionsFiltered: []
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "filterSuggestions", function (suggestions, value) {
      var filteredSuggestions = [];

      if (value.length) {
        filteredSuggestions = suggestions.filter(function (suggestion) {
          return suggestion.toLowerCase().indexOf(value.toLowerCase()) >= 0;
        });
        return filteredSuggestions.map(function (suggestion) {
          return {
            value: suggestion
          };
        });
      }

      return filteredSuggestions;
    });

    _this.state = {
      closed: true,
      highlightedIndex: 0,
      selectedIndex: 0,
      suggestionsFiltered: [],
      value: _this.props.value
    };
    return _this;
  }

  _createClass(Search, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onAction = _this$props.onAction,
          i18n = _this$props.i18n,
          className = _this$props.className,
          delay = _this$props.delay,
          disabled = _this$props.disabled,
          suggestions = _this$props.suggestions,
          other = _objectWithoutProperties(_this$props, ["onAction", "i18n", "className", "delay", "disabled", "suggestions"]);

      var _this$state2 = this.state,
          closed = _this$state2.closed,
          highlightedIndex = _this$state2.highlightedIndex,
          selectedIndex = _this$state2.selectedIndex,
          suggestionsFiltered = _this$state2.suggestionsFiltered,
          value = _this$state2.value;
      var classes = {
        'vn-search__input': true
      };

      if (className) {
        classes[className] = true;
      }

      var isSuggestionSelected = suggestionsFiltered.length > 0 && suggestionsFiltered[selectedIndex];
      return _react.default.createElement("div", {
        className: "vn-search",
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement(_text_box.default, _extends({}, other, {
        autoComplete: "off",
        className: (0, _classnames.default)(classes),
        disabled: disabled,
        onChange: this.handleChange,
        onKeyDown: this.handleOnKeyDown,
        type: "search",
        value: value
      })), _react.default.createElement(_icon.default, {
        name: "search",
        className: "vn-search__icon",
        disabled: disabled
      }), (suggestionsFiltered.length > 0 || value && value.length > 0 && onAction && !closed) && _react.default.createElement("div", {
        className: "vn-search__suggestions"
      }, _react.default.createElement(_options_list.default, {
        action: i18n.action,
        highlightedIndex: highlightedIndex,
        selectedIndex: selectedIndex,
        options: suggestionsFiltered,
        onAction: onAction,
        onMouseDown: this.handleOptionMouseDown,
        onMouseMove: this.handleOptionMouseMove,
        value: isSuggestionSelected ? [suggestionsFiltered[selectedIndex].value] : [''],
        typedText: value
      })));
    }
  }]);

  return Search;
}(_react.default.Component);

Search.propTypes = {
  className: _propTypes.default.string,
  delay: _propTypes.default.number,
  disabled: _propTypes.default.bool,
  i18n: _propTypes.default.shape({
    action: _propTypes.default.string
  }),
  onChange: _propTypes.default.func.isRequired,
  onAction: _propTypes.default.func,
  suggestions: _propTypes.default.arrayOf(_propTypes.default.string),
  value: _propTypes.default.string
};
Search.defaultProps = {
  className: null,
  delay: 0,
  disabled: false,
  i18n: {
    action: 'Create New'
  },
  onAction: null,
  suggestions: [],
  value: undefined
};
Search.displayName = 'Search';
var _default = Search;
exports.default = _default;